export default __webpack_public_path__ + "static/media/Investors-Meet-01-09-2026.c66c574d.pdf";